var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCookie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3876 25.577C8.55821 25.5705 3.83416 20.8388 3.82776 15C4.24355 15.1176 4.67344 15.1777 5.1055 15.1787C6.53478 15.1892 7.87758 14.4942 8.69584 13.3203C9.42738 12.2622 9.58195 10.9077 9.10767 9.71146C9.41093 9.76564 9.71833 9.79324 10.0264 9.79397C11.3958 9.80419 12.6956 9.19002 13.5586 8.12492C14.4032 7.09128 14.7333 5.72945 14.4562 4.42297C20.2882 4.44196 25.0007 9.19283 24.9818 15.0343C24.9628 20.8758 20.2196 25.5959 14.3876 25.577Z",
    stroke: "currentColor",
    strokeWidth: 2.35045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0544 20.8761H12.0564V20.8781H12.0544V20.8761Z",
    stroke: "currentColor",
    strokeWidth: 2.35045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9305 18.5257H17.9325V18.5277H17.9305V18.5257Z",
    stroke: "currentColor",
    strokeWidth: 2.35045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2296 15H13.2316V15.002H13.2296V15Z",
    stroke: "currentColor",
    strokeWidth: 2.35045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1057 12.6495H19.1077V12.6515H19.1057V12.6495Z",
    stroke: "currentColor",
    strokeWidth: 2.35045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82776 9.12384H3.82976V9.12584H3.82776V9.12384Z",
    stroke: "currentColor",
    strokeWidth: 2.35045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70398 4.42297H9.70598V4.42497H9.70398V4.42297Z",
    stroke: "currentColor",
    strokeWidth: 2.35045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00305 4.42297H5.00505V4.42497H5.00305V4.42297Z",
    stroke: "currentColor",
    strokeWidth: 2.35045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/cookie.003098c3fe61615cbac40ed4c8c3ae54.svg";
export { ForwardRef as ReactComponent };